// Firebase App Hosting provides config via FIREBASE_WEBAPP_CONFIG
// Local development uses individual NEXT_PUBLIC_* environment variables
const getFirebaseConfig = () => {
  // Try Firebase App Hosting config first (server-side during build)
  if (process.env.FIREBASE_WEBAPP_CONFIG) {
    try {
      return JSON.parse(process.env.FIREBASE_WEBAPP_CONFIG);
    } catch (error) {
      console.warn('Failed to parse FIREBASE_WEBAPP_CONFIG:', error);
    }
  }

  // Try client-side Firebase App Hosting config
  if (process.env.NEXT_PUBLIC_FIREBASE_WEBAPP_CONFIG) {
    try {
      return JSON.parse(process.env.NEXT_PUBLIC_FIREBASE_WEBAPP_CONFIG);
    } catch (error) {
      console.warn('Failed to parse NEXT_PUBLIC_FIREBASE_WEBAPP_CONFIG:', error);
    }
  }

  // Fall back to individual environment variables for local development
  return {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
    measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
  };
};

export const firebaseConfig = getFirebaseConfig();
